import React from 'react';
import QRCode from '../QRCode';
import { BrandArrowIcon } from '../icons/BrandArrowIcon';
import { t } from './translations';

/**
 * Left column of the print template — QR code + "Powered by ShiftGears"
 * badge. Same markup is reused by used-VIN and new-model templates;
 * `size` and `shape` come in from the parent so each layout can pick its
 * own QR aesthetics.
 *
 * @param {object} props
 * @param {string} props.url — URL to encode.
 * @param {number} props.size — QR pixel size.
 * @param {'rounded' | 'sharp'} props.shape — eye / module shape.
 * @param {() => void} [props.onReady] — fired once qr-code-styling has
 *   appended the SVG to the DOM. Bulk-print uses this to throttle
 *   window.print() until every QR is on screen.
 */
// Memoized — all props are primitives or stable callbacks from parent
// (NewModelPrintTemplate / CarPrintTemplate). Avoids re-rendering the
// expensive QR canvas on unrelated parent updates. См. discussion на MR #787.
const QRColumn = React.memo(function QRColumn({ url, size, shape, language = 'fr', onReady }) {
  return (
    <div className="print-template__qr-col">
      <div className="print-template__qr-wrapper">
        <QRCode
          url={url}
          // href === url — на превью печати QR кликабелен, ведёт ровно туда же,
          // куда сканер телефона. Один источник истины (issue #942).
          href={url}
          size={size}
          fgColor="#000000"
          bgColor="#FFFFFF"
          centerLogo={<BrandArrowIcon />}
          shape={shape}
          onReady={onReady}
        />
      </div>
      <div className="print-template__powered">
        <span className="print-template__powered-text">{t('poweredBy', language)}</span>
      </div>
    </div>
  );
});

export default QRColumn;
